var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V376H496V256Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V256H496V16Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V496H496V376Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo);
export default __webpack_public_path__ + "static/media/CO.57987f2f20d3c2e9c120a3b772cdba93.svg";
export { ForwardRef as ReactComponent };